import React, { useState, useEffect, useReducer, useRef } from 'react';

import {
    Toolbar,
    Paper,
    Button,
    Grid,
    Typography,
    Checkbox,
    FormControlLabel,
} from '@material-ui/core';

import { grey } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';

import SaveIcon from '@material-ui/icons/Save';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';

import { Formik } from 'formik';

import SideMenu from '../../components/SideMenu';
import Alert from '../../components/Alert';
import Input from '../../components/Input';
import Select from '../../components/Select';
import Autocomplete from '../../components/Autocomplete';
import { ListPageHeading } from '../../components/ListPageLayout';

import api from '../../services/api';

const reduceDevices = (state, action) => {
    let newValues = [];
    console.log({ state })
    switch (action.type) {
        case 'single':
            if (action.checked && !state[action.deviceArray].includes(action.id)) {
                newValues = state[action.deviceArray];
                newValues.push(action.id);
            } else if (!action.checked && state[action.deviceArray].includes(action.id)) {
                newValues = state[action.deviceArray];
                let index = state[action.deviceArray].indexOf(action.id);
                newValues.splice(index, 1);
            } else {
                newValues = state[action.deviceArray];
            }
            return {
                ...state,
                [action.deviceArray]: newValues,
            }
        case 'all':
            if (action.checked) {
                newValues = state[action.deviceArray];
                for (let current of action.allDevices) {
                    if (!newValues.includes(current.id)) {
                        newValues.push(current.id);
                    }
                }
            } else {
                newValues = [];
            }
            return {
                ...state,
                [action.deviceArray]: newValues,
            }
        case 'reset':
            return { device_id: [], camera_id: [] };
        default: return state;
    }
};

export default function WantedCreate() {
    const classes = useStyles();

    const imageRef = useRef(null);

    let initialValues = {
        name: '',
        sex: 'unknown',
        role: 'visitor',
        face_image: null,
        notes: '',
        custom_inputs: [],
    };

    const [search, setSearch] = useState('');
    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });

    const [deviceIds, dispatchDeviceIds] = useReducer(reduceDevices, { device_id: [], camera_id: [] });

    const [image, setImage] = useState(null)

    const imageHandler = (e, setFieldValue) => {
        const reader = new FileReader()
        reader.onload = () => {
            if (reader.readyState === 2) {
                setImage(reader.result);
                setFieldValue('face_image', e.target.files[0]);
                console.log(e.target.files[0])
            }
        }
        reader.readAsDataURL(e.target.files[0]);
        // console.log("imagem: " + image)
    }

    const ImagePreview = ({ image }) => {
        const src = image;

        return (
            <img
                src={src}
                alt="Imagem de identificação"
                style={{ maxWidth: '100%', maxHeight: '100%' }}
            />
        );
    };

    const [cameras, setCameras] = useState([]);

    useEffect(() => {
        const findCameras = async () => {
            try {
                const result = await api.get('/camera/list', {
                    params: {
                        search,
                        limit: 30,
                    }
                });

                const { cameras } = result.data;

                setCameras(cameras);
                console.log({ cameras })
            }
            catch (err) {
                console.log(err);
            }
        };

        findCameras();
    }, [search]);

    const saveUser = async (values, formik) => {
        try {

            const data = new FormData();

            data.append('face_image', values.face_image);

            if (!values.org_id) values.org_id = undefined;

            const userData = {
                ...values,
                camera_id: deviceIds.camera_id,
            };

            userData.face_image = undefined;

            data.append('user_data', JSON.stringify(userData));

            const result = await api.post('/wanted/create', data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            const { user } = result.data;
            dispatchDeviceIds({ type: 'reset' });
            setImage(null);
            resetForm(formik);

            formik.setSubmitting(false);

            setMessage({
                open: true,
                variant: 'success',
                text: `Procurado ${user.name} cadastrado(a) com sucesso!`,
            });
        }
        catch (err) {
            console.log(err)
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
        }
    };

    const resetForm = formik => {
        formik.resetForm();
    };

    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };


    const [customInputs, setCustomInputs] = useState([]);

    useEffect(() => {
        const findInputs = async () => {
            try {
                const result = await api.get('/custom_input/list', {
                    params: {
                        target: ['wanted'],
                        page: 0,
                        limit: 30,
                    }
                });

                const { custom_inputs } = result.data;

                setCustomInputs(custom_inputs);
            }
            catch (err) {
                console.log(err);
            }
        };

        findInputs();
    }, []);

    return (
        <div className={classes.root}>
            <SideMenu />
            <main className={classes.content}>
                <Toolbar />
                <Grid container spacing={3} className={classes.pageGrid}>
                    <Grid item xs={12}>
                        <div className={classes.pageHeader}>
                            <ListPageHeading icon="person" title="Cadastrar pessoa procurada" />
                            <Typography className={classes.pageSubtitle}>
                                Registre a identificação, as características e as câmeras utilizadas no monitoramento.
                            </Typography>
                        </div>
                    </Grid>
                    <Formik
                        initialValues={initialValues}
                        onSubmit={saveUser}
                    >
                        {({ values, setFieldValue, handleChange, handleSubmit, isSubmitting }) => (
                            <>
                                <Grid item xs={12}>
                                    <Paper elevation={0} className={classes.paper}>
                                        <form id="guest-create" onSubmit={handleSubmit} className={classes.form}>
                                            <div className={classes.formHeader}>
                                                <Typography className={classes.formHeaderTitle}>
                                                    Informações da pessoa procurada
                                                </Typography>
                                                <Typography className={classes.formHeaderSubtitle}>
                                                    Adicione uma foto nítida e selecione as câmeras relacionadas ao monitoramento.
                                                </Typography>
                                            </div>
                                            <div className={classes.formBody}>
                                            <Grid container spacing={3}>
                                                <Grid item xs={12} md={4} lg={3} className={classes.photoSection}>
                                                    <div className={classes.faceImageContainer}
                                                        style={{
                                                                height: '300px',
                                                                width: '100%',
                                                            }}
                                                        >
                                                        <div
                                                            className={classes.faceImageContent}
                                                            style={{
                                                                width: '100%',
                                                                height: '200px',
                                                            }}
                                                        >
                                                            {image ? (
                                                                <ImagePreview image={image} />
                                                            ) : (
                                                                <div className={classes.noImage}>
                                                                    <PhotoCameraIcon />
                                                                    <Typography variant="subtitle2">
                                                                        SEM IMAGEM
                                                                    </Typography>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {image && (
                                                            <Button
                                                                className={classes.removeImageButton}
                                                                size="small"
                                                                type="button"
                                                                variant="outlined"
                                                                color="secondary"
                                                                endIcon={<DeleteIcon />}
                                                                fullWidth
                                                                onClick={() => {
                                                                    setFieldValue('face_image', null)
                                                                    setImage(null)
                                                                    imageRef.current.value = null;
                                                                }}
                                                            >
                                                                Remover
                                                            </Button>
                                                        )}
                                                        <Button
                                                            className={classes.faceImageButton}
                                                            type="button"
                                                            variant="outlined"
                                                            color="primary"
                                                            endIcon={<PhotoCameraIcon />}
                                                            fullWidth
                                                            id={'take_pic'}
                                                            component="label"
                                                        >
                                                            Adicionar Foto
                                                            <input
                                                                name='face_image'
                                                                type="file"
                                                                accept="image/*"
                                                                ref={imageRef}
                                                                onChange={(e) => imageHandler(e, setFieldValue)}
                                                                hidden
                                                                required={false}
                                                            />
                                                        </Button>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={12} md={8} lg={9} className={classes.formSection}>
                                                    <Typography variant="subtitle1" className={classes.formSectionTitle}>
                                                        DADOS PESSOAIS
                                                    </Typography>
                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12} md={9}>
                                                            <Input
                                                                label="Nome/Apelido"
                                                                textFieldProps={{
                                                                    name: 'name',
                                                                    placeholder: 'Nome/Apelido',
                                                                    onChange: (e) => {
                                                                        const letras = e.target.value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ\s]/g, '');
                                                                        setFieldValue('name', letras);
                                                                    },
                                                                    value: values.name,
                                                                    fullWidth: true,
                                                                    required: false,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={3}>
                                                            <Select
                                                                label="Sexo"
                                                                options={[
                                                                    { label: '-- Selecione --', value: 'unknown', id: 'unknown' },
                                                                    { label: 'Masculino', value: 'male', id: 'male' },
                                                                    { label: 'Feminino', value: 'female', id: 'female' },
                                                                ]}
                                                                textFieldProps={{
                                                                    name: 'sex',
                                                                    onChange: handleChange,
                                                                    fullWidth: true,
                                                                    value: values.sex,
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12} className={classes.formSection} style={{ marginTop: '10px' }}>
                                                        <Typography variant="subtitle1" className={classes.formSectionTitle}>
                                                            OBSERVAÇÕES
                                                        </Typography>
                                                        <Grid item xs={12} style={{ height: '100%' }}>
                                                            <textarea
                                                                placeholder="Escreva o texto aqui"
                                                                multiline
                                                                minRows={25}
                                                                className={classes.notesField}
                                                                value={values.notes}
                                                                onChange={({ target }) => setFieldValue('notes', target.value)}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid container className={classes.formSection}>
                                                <Typography variant="subtitle1" className={classes.formSectionTitleTwo}>
                                                    INFORMAÇÕES PERSONALIZADAS
                                                </Typography>
                                                <Grid container spacing={3}>
                                                    {customInputs.map((input, index) => {
                                                        if (index === 0 && values.custom_inputs.length === 0) {
                                                            values.custom_inputs = customInputs
                                                        }

                                                        return (
                                                            <Grid key={index} item xs={12} sm={6} md={4}>
                                                                {
                                                                input.type === "normal" ? (

                                                                    <Input
                                                                        label={input.name}
                                                                        textFieldProps={{
                                                                            id: `custom_inputs${index}.information`,
                                                                            name: `custom_inputs[${index}].information`,
                                                                            onChange: handleChange,
                                                                            value: values.custom_inputs[index].hasOwnProperty('information') ? values.custom_inputs[index]['information'] : '',
                                                                            fullWidth: true,
                                                                            required: input.is_required,
                                                                        }}

                                                                        />
                                                                ) : (

                                                                        <Autocomplete
                                                                            label={input.name}
                                                                            id={`custom_inputs${index}.information`}
                                                                            options={input.options?.length && input.options.map((option) => ({ name: option, value: option, id: option }))}
                                                                            getOptionLabel={({ name }) => name || ''}
                                                                            onChange={(_, value) => setFieldValue(`custom_inputs[${index}].information`, value)}
                                                                            getOptionSelected={(option, value) => (option.id === value.id)}
                                                                            /* onInputChange={(_, value) => setPersonTypeSearch(value)} */
                                                                            value={values.custom_inputs[index].hasOwnProperty('information') ? values.custom_inputs[index]['information'] : ''}
                                                                            required={input.is_required}
                                                                            fullWidth
                                                                            />
                                                                    )
                                                                }
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} className={classes.formSection}>
                                                <Typography variant="subtitle1" className={classes.formSectionTitle}>
                                                    CÃMERAS
                                                </Typography>
                                                <Grid item xs={12}>
                                                    <Grid container className={classes.cameraToolbar}>
                                                        <Input
                                                            icon={<SearchIcon style={{ color: grey[400] }} />}
                                                            iconPosition="start"
                                                            textFieldProps={{
                                                                placeholder: 'Buscar…',
                                                                onChange: ({ target }) => setSearch(target.value),
                                                            }}
                                                        />
                                                        <Button
                                                            variant="outlined"
                                                            className={classes.button}
                                                            onClick={() => {
                                                                dispatchDeviceIds({
                                                                    type: 'all',
                                                                    checked: true,
                                                                    deviceArray: 'camera_id',
                                                                    allDevices: cameras,
                                                                });
                                                            }}
                                                        >
                                                            Selecionar todos
                                                        </Button>
                                                        <Button
                                                            variant="outlined"
                                                            className={classes.button}
                                                            onClick={() => {
                                                                dispatchDeviceIds({
                                                                    type: 'all',
                                                                    checked: false,
                                                                    deviceArray: 'camera_id',
                                                                });
                                                            }}
                                                        >
                                                            Desmarcar todos
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={3}>
                                                    {!!cameras && cameras.map((camera, index) => {
                                                        return (
                                                            <Grid item xs={12} sm={6} md={4} key={camera.id}>
                                                                <FormControlLabel
                                                                    label={
                                                                        <Typography variant="subtitle2" style={{
                                                                            userSelect: 'none'
                                                                        }}>
                                                                            {camera.name}
                                                                            <Typography variant="caption">
                                                                                ({camera?.place_cameras?.name})
                                                                            </Typography>
                                                                        </Typography>
                                                                    }
                                                                    control={
                                                                        <Checkbox
                                                                            name={`camera_[${camera.id}]`}
                                                                            checked={deviceIds.camera_id.includes(camera.id)}
                                                                            color="primary"
                                                                            onChange={(e) => {
                                                                                dispatchDeviceIds({
                                                                                    type: 'single',
                                                                                    checked: e.target.checked,
                                                                                    deviceArray: 'camera_id',
                                                                                    id: camera.id
                                                                                });
                                                                            }}
                                                                        />
                                                                    }
                                                                />
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                            </Grid>
                                            </div>
                                            <div className={classes.formActions}>
                                                <Button
                                                    disabled={isSubmitting}
                                                    type="submit"
                                                    variant="contained"
                                                    form="guest-create"
                                                    color="primary"
                                                    endIcon={<SaveIcon />}
                                                    className={classes.saveButton}
                                                >
                                                    {isSubmitting ? 'Salvando...' : 'Salvar dados'}
                                                </Button>
                                            </div>
                                        </form>
                                    </Paper>
                                </Grid>
                            </>
                        )}
                    </Formik>
                </Grid>
                {!!message.open && (
                    <Alert
                        open={message.open}
                        autoHideDuration={6000}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        severity={message.variant}
                        onClose={closeMessage}
                    >
                        {message.text}
                    </Alert>
                )}
            </main>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        minHeight: '100vh',
    },
    content: {
        flexGrow: 1,
        minWidth: 0,
        padding: theme.spacing(3),
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(6),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        },
    },
    pageGrid: {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 1440,
    },
    pageHeader: {
        display: 'flex',
        flexDirection: 'column',
    },
    pageSubtitle: {
        color: '#64748b',
        fontSize: '.82rem',
        lineHeight: 1.5,
        marginLeft: 64,
        marginTop: theme.spacing(.5),
        [theme.breakpoints.down('xs')]: {
            marginLeft: 0,
        },
    },
    paper: {
        backgroundColor: '#f8fafc',
        border: '1px solid #e5e7eb',
        borderRadius: 16,
        boxShadow: '0 10px 30px rgba(15, 23, 42, .05)',
        overflow: 'hidden',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    formHeader: {
        backgroundColor: '#fff',
        borderBottom: '1px solid #e5e7eb',
        padding: theme.spacing(2.5, 3),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        },
    },
    formHeaderTitle: {
        color: '#1e293b',
        fontSize: '1rem',
        fontWeight: 700,
    },
    formHeaderSubtitle: {
        color: '#64748b',
        fontSize: '.78rem',
        lineHeight: 1.45,
        marginTop: 2,
    },
    formBody: {
        padding: theme.spacing(3),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        },
    },
    photoSection: {
        marginBottom: theme.spacing(1),
    },
    formSection: {
        backgroundColor: '#fff',
        border: '1px solid #e2e8f0',
        borderRadius: 14,
        marginBottom: theme.spacing(2.5),
        padding: theme.spacing(2.25),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1.75),
        },
    },
    formSectionTitle: {
        color: '#334155',
        fontSize: '.78rem',
        fontWeight: 800,
        letterSpacing: '.055em',
        marginBottom: theme.spacing(1.75),
        width: '100%',
    },
    formSectionTitleTwo: {
        color: '#334155',
        fontSize: '.78rem',
        fontWeight: 800,
        letterSpacing: '.055em',
        marginBottom: theme.spacing(1.75),
        width: '100%',
    },
    faceImageContainer: {
        width: '100%',
        height: '303px',
        backgroundColor: '#fff',
        border: '1px solid #dbe3ec',
        borderRadius: 14,
        boxShadow: '0 6px 18px rgba(15, 23, 42, .06)',
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    faceImageContent: {
        width: '100%',
        flex: 7,
        background: 'linear-gradient(145deg, #f8fafc 0%, #eef4fb 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(1),
        '& img': {
            borderRadius: 9,
            objectFit: 'contain',
        },
    },
    faceImageButton: {
        borderBottom: 0,
        borderLeft: 0,
        borderRadius: 0,
        borderRight: 0,
        flex: 1,
        fontWeight: 600,
        minHeight: 42,
        textTransform: 'none',
    },
    removeImageButton: {
        borderBottom: 0,
        borderLeft: 0,
        borderRadius: 0,
        borderRight: 0,
        fontWeight: 600,
        minHeight: 40,
        textTransform: 'none',
    },
    noImage: {
        textAlign: 'center',
        color: '#94a3b8',
        '& svg': {
            fontSize: 42,
            marginBottom: theme.spacing(.5),
        },
        '& h6': {
            fontSize: '.72rem',
            fontWeight: 700,
            letterSpacing: '.08em',
        },
    },
    notesField: {
        backgroundColor: '#fff',
        border: '1px solid #cbd5e1',
        borderRadius: 10,
        boxSizing: 'border-box',
        color: '#475569',
        fontFamily: 'inherit',
        fontSize: '.9rem',
        lineHeight: 1.5,
        minHeight: 170,
        outline: 'none',
        padding: theme.spacing(1.5),
        resize: 'vertical',
        transition: 'border-color .2s ease, box-shadow .2s ease',
        width: '100%',
        '&:focus': {
            borderColor: '#1976d2',
            boxShadow: '0 0 0 3px rgba(25, 118, 210, .12)',
        },
    },
    cameraToolbar: {
        alignItems: 'center',
        display: 'flex',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(2),
        '& .MuiTextField-root': {
            minWidth: 260,
        },
        [theme.breakpoints.down('sm')]: {
            alignItems: 'stretch',
            flexDirection: 'column',
            '& .MuiTextField-root': {
                minWidth: 0,
                width: '100%',
            },
        },
    },
    button: {
        backgroundColor: '#fff',
        borderColor: '#cbd5e1',
        borderRadius: 9,
        boxShadow: '0 4px 12px rgba(15, 23, 42, .05)',
        color: '#334155',
        fontWeight: 700,
        minHeight: 42,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#f8fafc',
            borderColor: '#93c5fd',
        },
    },
    saveButton: {
        borderRadius: 9,
        boxShadow: '0 6px 14px rgba(25, 118, 210, .2)',
        fontWeight: 700,
        minHeight: 44,
        minWidth: 180,
        textTransform: 'none',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    formActions: {
        alignItems: 'center',
        backgroundColor: '#fff',
        borderTop: '1px solid #e5e7eb',
        display: 'flex',
        justifyContent: 'flex-end',
        padding: theme.spacing(2, 3),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1.5, 2),
        },
    },
}));
